import React from 'react';
import PreLoginPage from './../core/PreLoginPage';

export default class TestComplete extends PreLoginPage{
	
	render(){
		return (

			<div className="errorContainer">
			<div className="errorback text-center">
			<div className="fff">
			<div id="temp_test_complete"><span className="f40 fwb">
			Test Complete! This is a temporary page.</span>
			<div>
			<div className="f30"><span>Let&#39;s get you back <a href="/contest/report" className="r-btn errHome">Contest</a> </span></div>
			</div>
			</div>
			</div>
			</div>
			</div>

			)
		}

	}


// WEBPACK FOOTER //
// ./src/views/temp/TestComplete.js